export const CHECKBOX_TYPES = [{}, { isInvalid: true }, { disabled: true }]
